module.exports = "/_next/static/images/dd02bcf2ca54dc3cff0df0fb6aa014c1-ballons-icon.svg.webp";